<script setup lang="ts">
interface Props {
  size?: number;
  list: { id?: number; name: string }[];
  selected?: number | string;
  hasEmpty?: boolean;
}
withDefaults(defineProps<Props>(), {
  size: 32,
  hasEmpty: false,
});

const isOpen = ref<boolean>(false);

function toggleView() {
  isOpen.value = !isOpen.value;
}

const menu = ref(null);

onClickOutside(menu, () => (isOpen.value = false));

const emit = defineEmits<{
  onSelectId: [value: number];
  onSelectName: [value: string];
}>();

// クリックした項目のidとnameを親に渡す
function onClickItem(id?: number, name?: string) {
  emit("onSelectId", id ?? 0);
  emit("onSelectName", name ?? "");
  isOpen.value = false;
}
</script>

<template>
  <div class="relative" ref="menu">
    <div
      class="flex justify-between items-center rounded cursor-pointer hover:bg-gray-100"
      @click="toggleView"
    >
      <slot name="title"></slot>
      <Icon
        :size="size.toString()"
        :name="isOpen ? 'mdi:chevron-up' : 'mdi:chevron-down'"
      />
    </div>
    <Transition name="overlay">
      <div
        class="absolute min-w-full top-full left-0 z-10 bg-white border rounded shadow-lg whitespace-nowrap"
        v-show="isOpen"
      >
        <ul class="max-h-[300px] overflow-y-scroll">
          <li
            v-if="hasEmpty"
            class="hover:bg-gray-100 cursor-pointer p-2"
            @click="onClickItem()"
          >
            <slot name="empty_item_label">すべて</slot>
          </li>
          <li
            v-for="item in list"
            :key="item.id ?? item.name"
            class="hover:bg-gray-100 cursor-pointer p-2"
            :class="{
              'bg-gray-100': selected == item.id || selected == item.name,
            }"
            @click="onClickItem(item.id, item.name)"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>
    </Transition>
  </div>
</template>
